<template>
  <div class="footer">
    <div v-for="(item, index) in datalist" :key="index" class="van-row">
      <div class="span32">
        <span>
          <van-tag
            :color="
              item.status === 0
                ? 'rgba(255, 78, 52, .2)'
                : item.status === 1
                ? 'rgba(34, 203, 140, .2)'
                : 'rgba(239, 156, 44, .2)'
            "
            :text-color="
              item.status === 0
                ? 'rgba(255, 78, 52, 1)'
                : item.status === 1
                ? 'rgba(34, 203, 140, 1)'
                : 'rgba(239, 156, 44, 1)'
            "
            type="primary"
            >{{ item.branchName }}</van-tag
          >
          {{ item.title }}</span
        ><span>
          <img :src="require('../assets/home/time.png')" alt="" />
          {{ item.createTime }}</span
        >
      </div>
      <div class="span33" @click="toWarnDetail('/warningDetail', index)">
        <span
          :class="
            item.status === 1
              ? 'active'
              : item.status === 2
              ? 'active1'
              : 'active2'
          "
          >{{
            +item.status === 1
              ? "已处理"
              : item.status === 2
              ? "待处理"
              : "未处理"
          }}</span
        >
        <van-icon name="arrow" />
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  props: ["datalist"],
  data() {
    return {
      tabsIndex: 0,
    };
  },
  methods: {
    onClickDisabled() {
      Toast("无当前数据");
    },
    toWarnDetail(params, index) {
      this.$router.push({
        path: params,
        query: {
          id: this.datalist[index].id,
        },
      });
      this.$store.commit("changesafely", { index });
    },
  },
};
</script>

<style lang="less" scoped>
.footer {
  margin-top: 10px;

  .footerTitle {
    background: #fff;
    text-align: left;
    padding: 10px;
    height: 30px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;

    & > div {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      & > span {
        font-size: 18px;
        font-weight: bolder;
        letter-spacing: 2px;
      }
    }

    i {
      width: 4px;
      height: 18px;
      background-color: rgba(70, 122, 255, 1);
      margin-right: 10px;
      border-radius: 4px;
    }

    & > span {
      margin-top: 5px;
      color: #b5b5b5;
      cursor: pointer;

      & > img {
        width: 0.3rem;
        height: 0.3rem;
      }
    }
  }

  .van-row {
    background-color: rgb(255, 255, 255);
    padding-left: 15px;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(232, 232, 232, 0.67);
    box-sizing: border-box;
    // padding: 0 10px;
    // margin-bottom: 10px;
    .span31 {
      width: 70px;

      .icon-tishi,
      .icon-tishi1 {
        font-size: 30px;
      }
    }

    .span32 {
      flex: 1;
      display: flex;
      align-items: flex-start;
      justify-content: space-around;
      flex-direction: column;

      & > span:first-child {
        color: #333;
        line-height: 30px;
        font-size: 0.3rem;

        & > .van-tag {
          margin-right: 0.2rem;
        }
      }

      & > span:nth-child(2) {
        color: rgba(35, 39, 38, 0.4);
        font-size: 10px;
        line-height: 20px;

        img {
          width: 10px;
          height: 10px;
          vertical-align: middle;
        }
      }
    }

    .span33 {
      color: #777777;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 5px;

      & > .van-icon {
        font-size: 16px;
      }

      & > .active {
        color: rgba(34, 203, 140, 0.9);
      }

      & > .active1 {
        color: rgba(239, 156, 44, 0.9);
      }

      & > .active2 {
        color: rgba(255, 78, 52, 0.9);
      }
    }
  }
}
</style>
